import $ from 'jquery'


// Header scroll based classes

const el = $( '.header-sticky' );
const elHeight = el.outerHeight();
let scrollTop = $( window ).scrollTop();
let lastScrollTop = 0;

if ( scrollTop > 0 ) {
	el.addClass( 'header-scrolled-pos' );
} else {
	el.addClass( 'header-initial-pos' );
}

$( window ).on('scroll', function( event ){
	let scrollTop = $( this ).scrollTop();

	if ( scrollTop > 0 ) {
		el.removeClass( 'header-initial-pos' ).addClass( 'header-scrolled-pos' );
	} else {
		el.removeClass( 'header-scrolled-pos' ).addClass( 'header-initial-pos' );
	}

	if ( scrollTop > elHeight ) {
		if ( scrollTop > lastScrollTop ) {
			$( 'body' ).removeClass( 'scroll-up' ).addClass( 'scroll-down' );
		} else {
			$( 'body' ).removeClass( 'scroll-down' ).addClass( 'scroll-up' );
		}
	}

	lastScrollTop = scrollTop
})



// Header search

$( '.js-toggle-search' ).on( 'click', function( e ) {
	e.preventDefault();
	$( '.header-search' ).toggleClass( 'is-visible' );
  $( '.header-search input' ).get(0).focus();
} );

$( document ).on("keydown", function ( e ) {
	if ( e.key == "Escape" ) {
		$( '.header-search' ).removeClass( 'is-visible' );
	}
});

$( document ).on( 'click', function( e ) {
  if ( !$( '.js-toggle-search, .header-search' ).is( e.target ) && $( '.header-search' ).has( e.target ).length === 0) {
    $( '.header-search' ).removeClass( 'is-visible' );
  }
});
